import { DRAFT_RETENTION_DAYS } from 'utils/purchaseFlowDrafts'

const STORAGE_KEY = 'pf-placed-sessions'
const MAX_ENTRIES = 50
const RETENTION_MS = DRAFT_RETENTION_DAYS * 24 * 60 * 60 * 1000

/** A purchase session this browser placed an order from. */
export interface PlacedSession {
  orderId: number
  placedAt: number
}

type PlacedSessions = Record<string, PlacedSession>

const read = (): PlacedSessions => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed as PlacedSessions : {}
  }
  catch {
    return {}
  }
}

/** Records that the session ended in an order, so reopening its URL can say so instead of offering a blank flow. */
export const rememberPlacedSession = (
  sessionId: string,
  orderId: number,
  { now = Date.now() }: { now?: number } = {}
): void => {
  const kept = Object.entries(read())
    .filter(([, entry]) => now - entry.placedAt < RETENTION_MS)
    .sort(([, a], [, b]) => b.placedAt - a.placedAt)
    .slice(0, MAX_ENTRIES - 1)
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...Object.fromEntries(kept), [sessionId]: { orderId, placedAt: now } }))
  }
  catch {
    // A full or blocked storage only costs the "already ordered" message.
  }
}

/** The order this browser placed from the session, if any. */
export const placedSessionOrder = (sessionId: string): PlacedSession | null => read()[sessionId] ?? null
